/**
 * Normalize Vietnamese text for search — remove diacritics, lowercase, trim.
 * Used for client-side filtering and search comparison.
 */

const DIACRITICS_MAP: Record<string, string> = {
  àáảãạ: 'a',
  ăằắẳẵặ: 'a',
  âầấẩẫậ: 'a',
  đ: 'd',
  èéẻẽẹ: 'e',
  êềếểễệ: 'e',
  ìíỉĩị: 'i',
  òóỏõọ: 'o',
  ôồốổỗộ: 'o',
  ơờớởỡợ: 'o',
  ùúủũụ: 'u',
  ưừứửữự: 'u',
  ỳýỷỹỵ: 'y',
};

const DIACRITICS_REGEX = /[àáảãạăằắẳẵặâầấẩẫậđèéẻẽẹêềếểễệìíỉĩịòóỏõọôồốổỗộơờớởỡợùúủũụưừứửữựỳýỷỹỵ]/g;

function replaceDiacritics(char: string): string {
  for (const [chars, replacement] of Object.entries(DIACRITICS_MAP)) {
    if (chars.includes(char)) return replacement;
  }
  return char;
}

/** Remove Vietnamese diacritics and lowercase. */
export function normalizeText(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // strip combining diacritical marks
    .toLowerCase() // lowercase first so uppercase \u0110 maps via the lowercase \u0111 entry
    .replace(DIACRITICS_REGEX, replaceDiacritics)
    .trim();
}

/** Check if `query` matches `target` (case-insensitive, diacritics-insensitive). */
export function matchesSearch(query: string, target: string): boolean {
  const normalizedQuery = normalizeText(query);
  const normalizedTarget = normalizeText(target);
  return normalizedTarget.includes(normalizedQuery);
}
